import type { EmbeddedSpeechifyExperience } from "https://storage.googleapis.com/speechify-api-cdn/speechifyapi.min.mjs";
import { atom } from "jotai";

export type ArticleSpeechPlayer = {
  articleSpeechPlayer?: EmbeddedSpeechifyExperience;
  isArticleSpeechPlayerPlaying?: boolean;
};

export const articleSpeechPlayerAtom = atom<ArticleSpeechPlayer>({
  articleSpeechPlayer: undefined,
  isArticleSpeechPlayerPlaying: false,
});
